import React from 'react';

const Kraam = () => (
	<svg viewBox="0 0 100 100" className="af-icon">
		<path className="kraam" d="M81.2,81.2H18.8V63.8h62.5V81.2z M21.2,78.8h57.5V66.2H21.2V78.8z M26.2,45h-2.5v15h2.5V45z M76.2,45h-2.5v15 h2.5V45z M75,41.2c-2,0-3.9-1-5-2.5c-1.1,1.5-3,2.5-5,2.5s-3.9-1-5-2.5c-1.1,1.5-3,2.5-5,2.5s-3.9-1-5-2.5c-1.1,1.5-3,2.5-5,2.5 s-3.9-1-5-2.5c-1.1,1.5-3,2.5-5,2.5s-3.9-1-5-2.5c-1.1,1.5-3,2.5-5,2.5c-3.4,0-6.2-2.8-6.2-6.2v-0.5l15.7-15.7h31l15.7,15.7V35 C81.2,38.4,78.4,41.2,75,41.2z M71.2,35c0,2.1,1.7,3.8,3.8,3.8c1.9,0,3.5-1.4,3.7-3.3L64.5,21.2h-29L21.3,35.5 c0.2,1.8,1.8,3.3,3.7,3.3c2.1,0,3.8-1.7,3.8-3.8h2.5c0,2.1,1.7,3.8,3.8,3.8s3.8-1.7,3.8-3.8h2.5c0,2.1,1.7,3.8,3.8,3.8 s3.8-1.7,3.8-3.8h2.5c0,2.1,1.7,3.8,3.8,3.8s3.8-1.7,3.8-3.8h2.5c0,2.1,1.7,3.8,3.8,3.8s3.8-1.7,3.8-3.8H71.2z"/>
	</svg>
);

export default Kraam;

